var map = {
	"./logo.svg": 275,
	"./pitch.svg": 274,
	"./soccer-large.svg": 380,
	"./soccer.svg": 717,
	"./timer.svg": 273,
	"./trotting-dark.svg": 381,
	"./trotting-large.svg": 382,
	"./trotting.svg": 718
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 716;